import { joinPath } from '../../core/utils';
import type { BaseInfoBlockOptions, BaseInfoPaths } from './types';

/** 按 pathPrefix + options 生成 form 路径 */
export function resolveBaseInfoPaths(prefix: string, options?: BaseInfoBlockOptions): BaseInfoPaths {
  const nameSegment = options?.nameField ?? 'name';
  const datacenterSegment = options?.datacenterField ?? 'datacenter';

  return {
    name: joinPath(prefix, nameSegment),
    description: joinPath(prefix, 'description'),
    workspace: joinPath(prefix, 'workspace'),
    namespace: joinPath(prefix, 'namespace'),
    datacenter: joinPath(prefix, datacenterSegment),
  };
}
